/**
 * Preserva mute/cam ao pausar o piso do Escritório Virtual por outra reunião
 * ou conflito de dispositivo — o resume não deve forçar mídia ligada.
 */

export const VO_DEVICE_CONFLICT_PAUSE_TITLE =
  "Outro app está usando câmera/microfone — volte a esta aba para retomar";

export const VO_FLOOR_RECONNECT_PAUSE_TITLE =
  "Reconectando ao escritório virtual…";

export function snapshotVoMediaBeforePause(current, previousSnapshot = null) {
  if (previousSnapshot && typeof previousSnapshot === "object") {
    return {
      muted: Boolean(previousSnapshot.muted),
      camOff: Boolean(previousSnapshot.camOff),
    };
  }
  return {
    muted: Boolean(current?.muted),
    camOff: Boolean(current?.camOff),
  };
}

/**
 * @returns {{ muted: boolean, camOff: boolean } | null}
 * `null` = não havia snapshot (resume idempotente / double-fire).
 */
export function restoreVoMediaAfterPause(snapshot) {
  if (!snapshot || typeof snapshot !== "object") {
    return null;
  }
  return {
    muted: Boolean(snapshot.muted),
    camOff: Boolean(snapshot.camOff),
  };
}

export function isVoDeviceConflictPauseTitle(title) {
  const t = String(title || "").trim().toLowerCase();
  if (!t) return false;
  return (
    t.includes("câmera/microfone") ||
    t.includes("camera/microfone") ||
    t.includes("conflito de dispositivo") ||
    t === VO_DEVICE_CONFLICT_PAUSE_TITLE.toLowerCase()
  );
}

export function isVoFloorReconnectPauseTitle(title) {
  return String(title || "").trim() === VO_FLOOR_RECONNECT_PAUSE_TITLE;
}
